import React from 'react';
import App from 'next/app';
import Script from 'next/script';
import { ApolloProvider } from '@apollo/client';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import { withBlaze } from '@blaze-cms/nextjs-tools';
import buildConfig from '../blaze.config';
import IndexPage from '../components/IndexPage';
import { RESPONSIVE_IMAGE_CONFIG } from '../constants';

import '../styles/sass/_fonts.scss'; // imported first to fix external css not loading
import '../styles/globals.css';
import '../styles/sass/main.scss';
import HomePageHeader from '../components/HomePageHeader';

class MyApp extends App {
  render() {
    const { Component, pageProps, apolloClient, router } = this.props;

    return (
      <>
        <Script id="gtm-blaze_after_interactive_event" strategy="afterInteractive">{`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
           'event': 'blaze_after_interactive'
          });
        `}</Script>
        <ApolloProvider client={apolloClient}>
          <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
            <IndexPage />
            <HomePageHeader />
            <div className="site-container">
              <main className="main">
                <Component {...pageProps} router={router} />
              </main>
            </div>
          </ResponsiveImageProvider>
        </ApolloProvider>
      </>
    );
  }
}

export default withBlaze(MyApp, buildConfig);
